function getPositions(data) {
  return data.map(r => r.latlng);
}

export default getPositions;
